import { CandidateDto } from '../../../../services/applicant_tracking/CandidateService/CandidateDto';
import { RecentApplicationData } from '../../../../services/v1/applicant_tracking/CandidateService';
import { REFERRAL_VALUE } from '../ApplicationForm';

export function buildCandidateDto(
  data: RecentApplicationData,
): Partial<CandidateDto> {
  return {
    company: data.company,
    jobTitle: data.jobTitle,
    yearsExperience: data.yearsExperience,
    academicDegree: data.academicDegree,
    portfolioUrl: data.portfolioUrl,
    salaryExpectation: data.salaryExpectation,
    salaryCurrency: data.salaryCurrency,
    candidateDetail: data.candidateDetail,
    hasWorkingVisa: data.hasWorkingVisa,
    sourceId: data.isReferral ? REFERRAL_VALUE : data.sourceId?.toString(),
    referralKnowledge: data.referralKnowledge,
    referrerUserId: data.referrerUserId?.toString(),
    referrerEmail: data.referrerEmail,
    resume: data.resume
      ? { id: data.resume.id, filename: data.resume.filename, size: 0 }
      : undefined,
    coverLetter: data.coverLetter
      ? {
          id: data.coverLetter.id,
          filename: data.coverLetter.filename,
          size: 0,
        }
      : undefined,
    documents:
      data.documents?.map((doc) => ({
        id: doc.id,
        filename: doc.filename,
        size: 0,
      })) ?? [],
  };
}
